import React from 'react';
export function Porque() {
  return <section className="bg-marron py-12 md:py-24 px-6 md:px-12" data-id="element-83">
      <div className="max-w-5xl mx-auto" data-id="element-84">
        <h2 className="font-labrada font-bold text-4xl md:text-5xl text-crema mb-12 md:mb-20 text-center md:text-left" data-id="element-85">
          No es solo un textil, es una historia
        </h2>

        <div className="flex flex-col gap-10 md:gap-16" data-id="element-86">
          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-87">
            <span className="font-labrada font-bold text-6xl md:text-7xl text-crema leading-none" data-id="element-88">
              01
            </span>
            <div data-id="element-89">
              <h3 className="font-labrada font-bold text-2xl text-crema mb-3" data-id="element-90">
                Fibras 100% naturales
              </h3>
              <p className="font-labrada text-crema/80 text-lg md:text-xl" data-id="element-91">
                Llama, oveja y vicuña. Sin sintéticos, sin mezclas.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-92">
            <span className="font-labrada font-bold text-6xl md:text-7xl text-crema leading-none" data-id="element-93">
              02
            </span>
            <div data-id="element-94">
              <h3 className="font-labrada font-bold text-2xl text-crema mb-3" data-id="element-95">
                Herencia familiar de generaciones
              </h3>
              <p className="font-labrada text-crema/80 text-lg md:text-xl" data-id="element-96">
                Lo que tejió mi abuelo en la Quebrada, lo tejo yo hoy.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-97">
            <span className="font-labrada font-bold text-6xl md:text-7xl text-crema leading-none" data-id="element-98">
              03
            </span>
            <div data-id="element-99">
              <h3 className="font-labrada font-bold text-2xl text-crema mb-3" data-id="element-100">
                Hecho para usar y vivir
              </h3>
              <p className="font-labrada text-crema/80 text-lg md:text-xl" data-id="element-101">
                No solo para mirar, para pisar, abrigar y vestir todos los días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}